import { UIGameMapMetropolisController } from '../ui_game_map/UIGameMapMetropolisController.ts';
import { UIGameCityImprovementAchievementController } from './UIGameCityImprovementAchievementController.ts';
import { UIGameMetropolisAchievementController } from './UIGameMetropolisAchievementController.ts';
import { MechanicValidatorCityImprovements } from '@colonist/game-mechanic-validators';
export class UIGameCityImprovement {
    constructor(uiGameManager, cityImprovementsState, robberState){
        this.uiGameManager = uiGameManager;
        this.cityImprovementsState = cityImprovementsState;
        this.cityImprovementsValidator = new MechanicValidatorCityImprovements(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.cityImprovementsState);
        new UIGameMapMetropolisController(this.uiGameManager, robberState);
        new UIGameMetropolisAchievementController(this.uiGameManager, this.cityImprovementsValidator);
        new UIGameCityImprovementAchievementController(this.uiGameManager, this.cityImprovementsValidator.getPlayerCityImprovementsState(this.uiGameManager.gameController.myColor));
    }
}
